import {
  ButtonIcon,
  EditActionIcon,
  DeleteActionIcon,
  RoundedIconVisibility,
} from 'components/Ui/styled';
import { format } from 'date-fns';
import { dateFnsFormat } from 'constants';
import { ActionWrapperBox } from 'components/Common/common.styled';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const renderAdminLinksActions = (
  params,
  handleEdit,
  handleDelete,
  handleView
) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleEdit(params)} data-testid="buttonIcon">
        <EditActionIcon />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleView(params)}
        data-testid="viewEngagement"
      >
        <RoundedIconVisibility />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleDelete(params)}
        data-testid="deleteButtonIcon"
      >
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const adminLinksColumns = (handleEdit, handleDelete, handleView) => [
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 120,
    renderCell: (params) =>
      renderAdminLinksActions(params, handleEdit, handleDelete, handleView),
  },
  {
    headerName: 'Name',
    field: 'name',
    width: 200,
    renderCell: renderCellExpand,
  },
  {
    headerName: 'Description',
    field: 'description',
    width: 200,
    renderCell: renderCellExpand,
  },
  { headerName: 'Active', field: 'active', width: 100, type: 'boolean' },
  { headerName: 'URL', field: 'url', width: 200, renderCell: renderCellExpand },
  { headerName: 'Created At', field: 'createdAt', width: 150 },
  { headerName: 'Updated At', field: 'updatedAt', width: 150 },
  { headerName: 'Active Until', field: 'activeUntil', width: 150 },
];

export const getAdminLinksListData = (adminLinksData) => {
  if (!adminLinksData || adminLinksData?.length === 0) {
    return [];
  }

  return adminLinksData.map((item) => {
    return {
      ...item,
      id: item?.id,
      url: item?.url,
      name: item?.name,
      active: item?.active,
      subjectId: item?.subjectId,
      description: item?.description,
      createdAt: item?.createdAt
        ? format(new Date(item.createdAt), dateFnsFormat)
        : '',
      updatedAt: item.updatedAt
        ? format(new Date(item.updatedAt), dateFnsFormat)
        : '',
      activeUntil: item.activeUntil
        ? format(new Date(item.activeUntil), dateFnsFormat)
        : '',
    };
  });
};
